// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.isFree[data-v-3a2d3382] {\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
